import React from "react"
import styled from "styled-components"
import { Field, FieldProps } from "react-final-form"
import MaskedInput from "react-text-mask"
import { FontConfigurations, typography } from "theme"

import { DefaultField, DefaultFieldProps, getValidator } from "components/form"
import { INPUT_CSS } from "components/form/shared/default-field/styles"

/*
  This is a workaround for a known issue when using styled-components with external components
  Github issue for reference: https://github.com/styled-components/styled-components/issues/305
*/
const Input = styled(({ lineHeight: _l, handleResetError: _h, children, ...restProps }) => (
  <MaskedInput {...restProps}>{children}</MaskedInput>
)).attrs({
  ...FontConfigurations.p,
  keepCharPositions: true,
  mask: [/\d/, /\d/, " ", "/", " ", /\d/, /\d/, " ", "/", " ", /\d/, /\d/, /\d/, /\d/]
})`
  ${INPUT_CSS}
  ${typography}
`

export function DateInputField(props: FieldProps<string, HTMLInputElement>) {
  const validate = getValidator(props.validate, props.required)

  return (
    <Field
      InputComponent={Input}
      placeholder="MM / DD / YYYY"
      parse={value => (value ? value.replace(/ /g, "") : value)}
      {...props}
      validate={validate}
      pattern="[0-9]*"
      type="tel"
    >
      {(inputProps: DefaultFieldProps<string>) => (
        <DefaultField id={`date-${props.name}`} dataTest={props.dataTest} {...inputProps} />
      )}
    </Field>
  )
}

export default DateInputField
